@if (hidePanel) {
    <div class="w-100 p-24">
        <af-contact-details-form [contactForm]="contactForm"
                         [showAddContactButton]="showAddContactButton"
                         [isAddContactButtonDisabled]="isAddContactButtonDisabled"
                         [msisdnPredefinedValue]="msisdnPredefinedValue"
                         [msisdnReadOnly]="msisdnReadOnly"
                         [existingAttachments]="existingAttachments"
                         (addNewContactListener)="addNewContactListener.emit()"
                         (addLinkListener)="addLinkListener.emit()"
                         (removeLinkListener)="removeLinkListener.emit($event)"/>
    </div>
} @else {
    <mat-expansion-panel
        class="w-100"
        [class.mt-12]="index > 0"
        [hideToggle]="Spinner.isShown('initForms')"
        [disabled]="Spinner.isShown('initForms')"
        [(expanded)]="expanded">
        <mat-expansion-panel-header class="w-100"
                                    [class.loading]="Spinner.isShown('initForms')"
                                    fxLayout="start space-between">
            <mat-panel-title class="no-wrap t2-semi-bold">
                <div class="radius-4 bc-primary-green-100 c-primary-gray-900 pl-12 pr-12">
                    {{ 'i18n_af_labelContactTitle' | translate: {index: viewIndex} }}
                </div>
            </mat-panel-title>
            @if (Spinner.isShown('initForms')) {
                <mat-panel-description fxLayoutAlign="end">
                    <ui-kit-spinner [diameter]="16" [strokeWidth]="3" spinnerIds="initForms"/>
                </mat-panel-description>
            }
            @if (showDeleteButton) {
                <mat-panel-description fxLayoutAlign="end">
                    <ui-kit-button type="text"
                                   color="accent"
                                   class="mr-16"
                                   [isSmall]="true"
                                   (clickListener)="deleteContactListener.emit(index)"
                                   [label]="'i18n_af_buttonDeleteContact' | translate"/>
                </mat-panel-description>
            }
        </mat-expansion-panel-header>
        <af-contact-details-form [contactForm]="contactForm"
                         [showAddContactButton]="showAddContactButton"
                         [isAddContactButtonDisabled]="isAddContactButtonDisabled"
                         [msisdnPredefinedValue]="msisdnPredefinedValue"
                         [msisdnReadOnly]="msisdnReadOnly"
                         [existingAttachments]="existingAttachments"
                         (addNewContactListener)="addNewContactListener.emit()"
                         (addLinkListener)="addLinkListener.emit()"
                         (removeLinkListener)="removeLinkListener.emit($event)"/>
    </mat-expansion-panel>
}
